import { ProfileCareerSaveVO } from '@domain/rq/profile/ProfileCareerSaveRq';
import { CareersVO } from '@domain/vo/profile/ProfileCareersVO';
import { BasicCompanyInfoDto } from '@domain/rs/profile/career/CompaniesRs';
import { EmploymentStatusType, EmploymentType } from '@domain/constant/profile/CareerType';
import { ReactSelectOption } from '@domain/constant/ReactSelectOption';
import DateFormat from '@utils/date/format';

export class ProfileCareersFormVO {
  sn: number | null;
  company: ReactSelectOption<BasicCompanyInfoDto> | null;
  employmentStatus: EmploymentStatusType | null; // 재직 상태
  startDate?: string | null;
  endDate?: string | null;
  jobGroup: ReactSelectOption | null; // 직군 코드
  jobTitle: ReactSelectOption | null; // 직무 코드
  employmentType: ReactSelectOption<EmploymentType> | null; // 계약 형태
  performance: string | null; // 주요 성과
  role: string | null; //역할
  verified: boolean | null;

  constructor(dto: ProfileCareersFormVO) {
    this.sn = dto.sn;
    this.company = dto.company;
    this.employmentStatus = dto.employmentStatus;
    this.startDate = DateFormat.getDateFormatString(dto.startDate, 'yyyy-MM');
    this.endDate = DateFormat.getDateFormatString(dto.endDate, 'yyyy-MM');
    this.jobGroup = dto.jobGroup;
    this.jobTitle = dto.jobTitle;
    this.employmentType = dto.employmentType;
    this.performance = dto.performance;
    this.role = dto.role;
    this.verified = dto.verified;
  }

  static convertProfileCareerFormVO = (vo: CareersVO): ProfileCareersFormVO => {
    const jobGroup = vo.jobGroupCode && vo.jobGroupName ? { value: vo.jobGroupCode, label: vo.jobGroupName } : null;
    const jobTitle = vo.jobTitleCode && vo.jobTitleName ? { value: vo.jobTitleCode, label: vo.jobTitleName } : null;
    const employmentType =
      vo.employmentType && vo.employmentTypeText ? { value: vo.employmentType, label: vo.employmentTypeText } : null;

    return new ProfileCareersFormVO({
      sn: vo.sn,
      company: { value: { name: vo.companyName, sn: vo.companySn }, label: vo.companyName },
      employmentStatus: vo.employmentStatus,
      startDate: DateFormat.getDateFormatString(vo.startDate, 'yyyy-MM'),
      endDate: DateFormat.getDateFormatString(vo.endDate, 'yyyy-MM'),
      jobGroup,
      jobTitle,
      employmentType,
      performance: vo.performance,
      role: vo.role,
      verified: vo.verified,
    });
  };

  static convertProfileCareerSaveVO = (vo: ProfileCareersFormVO): ProfileCareerSaveVO => {
    return new ProfileCareerSaveVO({
      sn: vo.sn,
      companyName: vo.company?.label ?? '',
      companySn: vo.company?.value.sn ? Number(vo.company?.value.sn) : null,
      employmentStatus: vo.employmentStatus || null,
      employmentType: vo.employmentType?.value || null,
      startDate: DateFormat.getDateFormatString(vo.startDate, 'yyyy-MM'),
      endDate: DateFormat.getDateFormatString(vo.endDate, 'yyyy-MM'),
      jobGroupCode: Number(vo.jobGroup?.value ?? -1),
      jobTitleCode: Number(vo.jobTitle?.value ?? -1),
      performance: vo.performance,
      role: vo.role,
      verified: vo.verified,
    });
  };
}
